import { gqlFetchList } from 'app/lib/graphqlClient'
import type { NamedLocationConsumer, ProviderOption, ProviderRecord } from 'app/types/provider-directory'
import { logError } from 'lib/logging'
import { providerFilterOptions } from 'lib/providerFilterOptions'

const PROVIDER_LIMIT = 500
const LOCATION_LIMIT = 500

/** The Provider filter's options, read from the workspace's `providers` and `locations`. */
export async function providerFilterFetcher(params: {
  query: string
}): Promise<{ hits: ProviderOption[]; total: number; page: number }> {
  try {
    const [providers, locations] = await Promise.all([
      gqlFetchList<ProviderRecord>(
        `providers`,
        { pagination: { limit: PROVIDER_LIMIT } },
        `vendorId displayName resourceName kollaConsumerId`,
      ),
      gqlFetchList<NamedLocationConsumer>(
        `locations`,
        { pagination: { limit: LOCATION_LIMIT } },
        `id name kollaConsumerId`,
      ),
    ])
    const hits = providerFilterOptions(providers.hits, locations.hits, params.query)
    return { hits, total: hits.length, page: 0 }
  } catch (err) {
    logError(`providerFilterFetcher failed`, err)
    return { hits: [], total: 0, page: 0 }
  }
}
